import React from 'react';
import Section from '../components/section';
import Socialmedia from '../components/static/socialmedia';
import SeminarReviews from '../components/static/seminar-reviews';
import PresentatiesReviews from '../components/static/presentaties-reviews';
import UpcomingEvents from '../components/static/upcoming-events';
import AllUpcomingEvents from '../components/static/all-upcoming-events';
import AllPastEvents from '../components/static/all-past-events';
import GoogleMaps from '../components/static/google-maps';
import WooCommerceProducts from '../components/static/woocommerce-products';
import PartnersLogos from '../components/static/partners-logos';
import AllPartners from '../components/static/all-partners';
import ROIPortals from '../components/static/roi-portals';
import ShopItem from '../components/static/shop-item';
import PdvHeader from '../components/static/pdv-header';

const componentMapping = {
  Socialmedia,
  Partners_logos: PartnersLogos,
  Partners_logos_slider: (...props) => (<PartnersLogos slider {...props} />),
  All_partners: AllPartners,
  Seminar_reviews: SeminarReviews,
  Presentaties_reviews: PresentatiesReviews,
  Upcoming_events: UpcomingEvents,
  All_upcoming_events: AllUpcomingEvents,
  All_past_events: AllPastEvents,
  Google_maps: GoogleMaps,
  WooCommerce_products: WooCommerceProducts,
  ROI_Portals: ROIPortals,
  Shop_item: ShopItem,
  PDV_Header: PdvHeader,
};

const Static = ({
  rowOptions,
  component,
}) => {
  const Component = componentMapping[component] || 'div';
  return (
    <Section
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
    >
      <Component rowOptions={rowOptions} />
    </Section>
  );
};

export default Static;
